// extracted by mini-css-extract-plugin
module.exports = {"link":"maintenancePage_link__RTkxP"};